import React from 'react';
import Button from '../ui/Button';

const chapters = [
  {
    period: 'Now',
    title: 'Making intelligence operational',
    context: 'Compliance platforms · Dataflow Group',
    copy: 'Building dependable operational systems and AI-powered engineering workflows—where intelligence must earn trust inside high-stakes, real-world processes.',
    lesson: 'AI becomes valuable when it improves a decision, shortens a feedback loop, or helps a person act with confidence.'
  },
  {
    period: 'Earlier',
    title: 'Learning scale through commerce',
    context: 'Retail and fintech · Arzooo',
    copy: 'Worked across merchant onboarding, inventory, finance, payments and post-sales experiences, learning how many invisible systems must align for a simple customer action to succeed.',
    lesson: 'The strongest architecture begins with a clear understanding of the operation it serves.'
  },
  {
    period: 'The beginning',
    title: 'Discovering systems through play',
    context: 'Gaming and engagement · Moonfrog Labs',
    copy: 'Built gameplay, social and analytics experiences for large player communities—my first deep lesson in behaviour, feedback loops and products that live in real time.',
    lesson: 'Technology is most interesting when you can see how people respond to what you create.'
  }
];

const ExperienceAndEducation: React.FC = () => (
  <section id="experience" className="experience-section py-24">
    <div className="section-transition" aria-hidden="true"><span>A journey, not a job list</span></div>
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="section-heading mb-14">
        <div><span className="section-eyebrow">The journey / 05</span><h2 className="text-4xl md:text-6xl font-bold text-white mt-3">Different domains. One evolving way of thinking.</h2></div>
        <div className="journey-intro"><p>I’ve worked across gaming, retail, fintech, compliance and platform engineering. The titles changed; the thread remained the same: understand the system, find the leverage, and build for real impact.</p><Button variant="outline" size="sm" href="https://drive.google.com/file/d/17lMCnLFWC2OAlFFjWKgH--m_jdQg2JhT/view?usp=sharing" target="_blank">View the formal résumé ↗</Button></div>
      </div>
      <div className="journey-list">
        {chapters.map((chapter, index) => (
          <article className="journey-chapter" key={chapter.title}>
            <div className="journey-marker"><span>0{index + 1}</span><i /></div>
            <div className="journey-period">{chapter.period}</div>
            <div className="journey-story"><span>{chapter.context}</span><h3>{chapter.title}</h3><p>{chapter.copy}</p></div>
            <blockquote><span>What stayed with me</span>{chapter.lesson}</blockquote>
          </article>
        ))}
      </div>
      <div className="education-note"><span>Formal foundation</span><p>Master of Technology in Computer Science · Indian Institute of Information Technology, Allahabad</p></div>
    </div>
  </section>
);

export default ExperienceAndEducation;
